import { useMemo } from "react";

import { createResourceStorageKeys } from "src/system/createResourceStorageKeys.ts";

export const useResourceStorageKeys = () => {
  return useMemo(() => createResourceStorageKeys(), []);
};
